"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardAction = CardAction;
exports["default"] = exports.INITIAL_CARD_PROPS = exports.CardSubject = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _excluded = ["listRef", "stack", "isLoading", "placeholder", "baseWidth"],
  _excluded2 = ["title", "onClick", "children", "color", "disabled"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var _default = exports["default"] = function _default(_ref) {
  var listRef = _ref.listRef,
    _ref$stack = _ref.stack,
    stack = _ref$stack === void 0 ? 0 : _ref$stack,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    placeholder = _ref.placeholder,
    baseWidth = _ref.baseWidth,
    cardProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var ref = (0, _react.useRef)(null);
  var stackedPaper = (0, _react.useMemo)(function () {
    var range = Math.min(Math.max(stack, 0), 2);
    return new Array(range).fill(null).map(function (_, index) {
      return /*#__PURE__*/_react["default"].createElement(StackedPaper, {
        key: index,
        index: index + 1
      });
    });
  }, [stack]);
  var card = (0, _react.useMemo)(function () {
    return isLoading ? placeholder : /*#__PURE__*/_react["default"].createElement(Card, cardProps);
  }, [isLoading, placeholder]);
  if (stack === 0) {
    return card;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex h-full relative"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    className: "relative h-full w-full transform-ease-out z-10",
    style: {
      width: baseWidth,
      minWidth: baseWidth
    }
  }, card, stackedPaper));
};
var INITIAL_CARD_PROPS = exports.INITIAL_CARD_PROPS = {
  info: {
    title: '',
    subtitle: '',
    avatar: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null),
    extra: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null)
  },
  tooltip: '',
  actions: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null),
  subject: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null),
  onClick: undefined
};
var Card = function Card(_ref2) {
  var className = _ref2.className,
    info = _ref2.info,
    subject = _ref2.subject,
    actions = _ref2.actions,
    onClick = _ref2.onClick,
    tooltip = _ref2.tooltip;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full p-4 pt-0 relative",
    style: {
      zIndex: 4
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('shadow-lg select-none bg-card h-full w-full dark:shadow-shallow', {
      'cursor-pointer': !!onClick
    }, className),
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: tooltip
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-4 pt-3 pb-0"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, info.avatar, /*#__PURE__*/_react["default"].createElement("div", {
    className: "min-w-0 ml-4 flex-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-sm font-semibold truncate text-dark"
  }, info.title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xs truncate text-gray-light"
  }, info.subtitle)), info.extra), /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-10 text-gray-light"
  }, /*#__PURE__*/_react["default"].isValidElement(subject) ? subject : /*#__PURE__*/_react["default"].createElement(CardSubject, null, subject)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-2 whitespace-no-wrap"
  }, _react["default"].Children.map(actions, function (action, index) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: index,
      className: "mr-4 last:mr-0"
    }, action);
  })))));
};
var CardSubject = exports.CardSubject = function CardSubject(_ref3) {
  var _ref3$italic = _ref3.italic,
    italic = _ref3$italic === void 0 ? false : _ref3$italic,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 'normal' : _ref3$size,
    children = _ref3.children;
  var isSmall = size === 'small';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('mt-1', {
      'text-sm truncate py-2': !isSmall,
      'text-xs py-1': isSmall,
      italic: italic
    })
  }, children);
};
function StackedPaper(_ref4) {
  var _ref4$index = _ref4.index,
    index = _ref4$index === void 0 ? 0 : _ref4$index;
  var styles = (0, _react.useMemo)(function () {
    return {
      zIndex: 3 - index,
      top: 0,
      right: -8 * index,
      paddingTop: "calc(".concat(10 * index, "px)"),
      paddingBottom: "calc(1rem + ".concat(10 * index, "px)")
    };
  }, [index]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full h-full absolute inline-block px-4",
    style: styles
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full shadow-lg h-full bg-card dark:shadow-shallow"
  }));
}
var colors = {
  primary: 'text-primary hover:bg-secondary',
  secondary: 'text-gray-light hover:bg-secondary'
};
function CardAction(_ref5) {
  var title = _ref5.title,
    _onClick = _ref5.onClick,
    children = _ref5.children,
    _ref5$color = _ref5.color,
    color = _ref5$color === void 0 ? 'primary' : _ref5$color,
    _ref5$disabled = _ref5.disabled,
    disabled = _ref5$disabled === void 0 ? false : _ref5$disabled,
    rest = (0, _objectWithoutProperties2["default"])(_ref5, _excluded2);
  var textColor = colors[color];
  return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, rest, {
    className: (0, _classnames["default"])('text-sm font-semibold py-1 px-2 rounded', (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, textColor, !disabled), 'text-gray-light cursor-not-allowed', disabled)),
    onClick: function onClick(e) {
      e.stopPropagation();
      !disabled && _onClick(e);
    }
  }), children);
}
//# sourceMappingURL=Card.js.map